
const WeakSet = require('core-js/fn/weak-set');

const $ = require('jquery');

import ko from 'rgs-knockout';

const server = require('server');

const { profile } = require('myrgs-auth-helpers');


class Model {
	constructor () {
		this._QuotationsForProlongationCount = ko.observable();

		this.Count = ko.pureComputed(() => {
			return this._QuotationsForProlongationCount();
		});

		this._getQuotationsForProlongation().done();
	}

	_getQuotationsForProlongation () {
		return profile.updateAtLeastOnce()
			.then(() => {
				if (profile.hasRole('PhysicalInsurantPerson')) {
					return server.my.api.lk.getQuotationsForProlongation();
				}
				return { responseJSON: { Data: [] } };
			})
			.then(({ responseJSON: { Data } }) => {
				this._QuotationsForProlongationCount(Data.length);
			});
	}
}


let model = null;
const applied = new WeakSet;

module.exports = function () {
	if (!model) {
		model = new Model;
	}

	$('[data-apply="page-my-common-menu-insurances-counter"]').each((i, el) => {
		if (applied.has(el)) {
			return;
		}

		const $counter = $('<span></span>', {
			class: [
				'list-group-item-rgs-menu-decoration',
				'list-group-item-rgs-menu-decoration-counter-danger',
			].join(' '),
		});

		$(el).append($counter);

		ko.applyBindingAccessorsToNode($counter[0], {
			text: function () {
				return model.Count();
			},
			visible: function () {
				return model.Count();
			},
		});

		applied.add(el);
	});
};
